import { render } from "./IndividualTombstonePanel.vue?vue&type=template&id=3e8c3b1a&scoped=true"
import script from "./IndividualTombstonePanel.vue?vue&type=script&lang=js"
export * from "./IndividualTombstonePanel.vue?vue&type=script&lang=js"

import "./IndividualTombstonePanel.vue?vue&type=style&index=0&id=3e8c3b1a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3e8c3b1a"

export default script